import { createReducer } from '@reduxjs/toolkit';
import { ISkillState } from './types';
import { fetchSkills } from './actions';

const initialSkillReducer: ISkillState = {
  loading: false,
  data: [],
  error: null,
};


export const skillReducer = createReducer(initialSkillReducer, (builder) => {
  builder
    .addCase(fetchSkills.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchSkills.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    })
    .addCase(fetchSkills.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})